import { Suspense, useEffect } from 'react'
import { LayoutPage } from '@/components/layout/page'
import { NoAccessError } from '@/lib/errors'
import { useCompanyBilling, useIdCompany, useRBAC } from '@/lib/hooks'
import { RoleID } from '@/lib/rbac'
import { Credits } from '@/routes/billing/credits'
import { BillingDangerZone } from '@/routes/billing/danger-zone'
import { BillingFallback } from '@/routes/billing/fallback'
import { HistoricalInvoices } from '@/routes/billing/historical-invoices'
import { ManageBilling } from '@/routes/billing/manage-billing'
import { PastDueInvoices } from '@/routes/billing/past-due-invoices'

export const BillingPage = () => {
  const { idCompany } = useIdCompany()
  const { rbac, rolesInCompany } = useRBAC()
  const { remainingCredits } = useCompanyBilling()

  const isSuperAdmin = rbac.kinsta().superadmin.can()

  useEffect(() => {
    if (!rbac.company(idCompany).billing.view.can()) {
      throw new NoAccessError()
    }
  }, [rbac, idCompany])

  const hasCredits = remainingCredits > 0
  const isOwner = rolesInCompany.some((role) => role === RoleID.COMPANY_OWNER)

  return (
    <LayoutPage browserTitle="Billing" fallback={<BillingFallback />}>
      <div className="flex flex-col gap-4 pb-25">
        <Suspense fallback={null}>
          <PastDueInvoices />
        </Suspense>
        {hasCredits ? (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <ManageBilling />
            <Credits />
          </div>
        ) : (
          <ManageBilling />
        )}
        <Suspense fallback={null}>
          <HistoricalInvoices />
        </Suspense>
        {isOwner || isSuperAdmin ? <BillingDangerZone /> : null}
      </div>
    </LayoutPage>
  )
}
